<template>
    <div class="content">
        <p
            v-if="searchAddressSelected !== null"
            id="infomessage"
        >
            {{ frequencyDataInfoMessage }}
        </p>
        <p
            v-if="searchAddressSelected !== null"
            id="infomessage"
        >
            {{ dataNotFoundMsg }}
        </p>
        <p>{{ infotext }}</p>
        <br>
        <div v-if="!isLoading">
            <!-- eslint-disable vue/no-v-html -->
            <p
                v-if="hasReservedFrequencies && showFrequencyData"
                v-html="reservedFrequencyInfoText"
            />
            <ul
                v-if="frequencyData && showFrequencyData"
                class="available-frequencies"
                aria-live="polite"
                :aria-describedby="frequencyDataInfoMessageVisible()"
            >
                <li
                    v-for="(value, index) in frequencyData"
                    :key="index"
                    :style="value.includes('img') ? 'color:#EB0000' : '' "
                    class="content-text-info"
                    v-html="value"
                />
            </ul>
            <p
                v-if="textContent != ''"
                v-html="textContent"
            />
            <!--eslint-enable-->
        </div>
        <br>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import DynamicRightSlotData from "../../../../models/dynamicrighslotdata"
    import SearchResultModel from "@/models/searchresultmodel"
    import useEventsBus from '../../../../eventBus'
    import { store } from '@/store/store'
    import i18n from '@/i18n'

    const t = i18n.global.t

    const { emit } = useEventsBus()

    @Component
    export default class Radiomikrofonitaajuudet extends Vue {
        resIcon = "<img class='reserved-icon' src='" + this.reservedIcon + "' alt='" + this.reservedIconAlt + "' style='width: 1rem; height: 1rem;'/>"

        get isLoading(): boolean {
            return store.getters.isLoading
        }

        get rightSlotData(): DynamicRightSlotData {
            return store.getters.rightSlotData as DynamicRightSlotData
        }

        get infotext(): string | undefined {
            if (this.searchAddressSelected !== null) {
                return t("App.Radiomikrofonitaajuudet.RightSlot.InfoText") + " " + this.searchAddressSelected.getFullName() + "."
            }
            return t("App.Radiomikrofonitaajuudet.InfoText")
        }

        get textContent() {
            return this.rightSlotData.textContent
        }

        get frequencyData() {
            return this.rightSlotData.frequencies
        }

        get frequencyDataInfoMessage() {
            return this.rightSlotData.messageFromApi
        }

        frequencyDataInfoMessageVisible() {
            return this.frequencyDataInfoMessage != null ? "infomessage" : null
        }

        get dataNotFoundMsg() {
            if ((this.frequencyData && this.frequencyData.length === 0) || !this.frequencyData) {
                return t("App.Radiomirofonitaajuudet.RightSlot.FrequencyDataInfoMessage.NotFound")
            }
        }

        get reservedFrequencyInfoText(): string | undefined {
            return this.resIcon + " " + t("App.Radiomikrofonitaajuudet.ReservedFrequencyInfoText")
        }

        get reservedIcon(): string {
            return store.getters.contentServiceUrl + "/Content/icons/svg/huutomerkki-pyorea-punainen.svg" + "?" + store.getters.contentServiceTimeStamp
        }

        get reservedIconAlt(): string | undefined {
            return t("App.Radiomikrofonitaajuudet.ReservedFrequencyAlt")
        }

        get searchAddressSelected(): SearchResultModel | null {
            return store.getters.searchAddressSelected
        }

        get hasReservedFrequencies(): boolean {
            if (this.frequencyData) {
                for (let i = 0; i < this.frequencyData.length; i++) {
                    if (this.frequencyData[i].includes("reserved-icon")) {
                        return true
                    }
                }
            }

            return false
        }

        // if coordinates haven't been given, then we don't list the available frequencies in the right slot
        get showFrequencyData() {
            return store.getters.frequencySearchData.lat.toString() !== "0" && store.getters.frequencySearchData.lng.toString() !== "0"
        }

        searchAddressFocus() {
            emit('addressInputFocus')
        }
    }
</script>
<style scoped>
    .available-frequencies {
        line-height: 0.7rem;
    }

        .available-frequencies > li {
            list-style-type: none;
        }

    p#infomessage {
        padding-bottom: 10px;
    }
</style>
